import { makeEnvironmentProviders } from '@angular/core';
import { ViewStateService } from '@mri-platform/shared/core';
import { provideState } from '@ngrx/store';
import * as fromViewState from './reducers';
import { DefaultViewStateService } from './services/default-view-state.service';

export function provideViewState() {
  return makeEnvironmentProviders([
    provideState(fromViewState.viewStateFeatureKey, fromViewState.reducer),
    { provide: ViewStateService, useClass: DefaultViewStateService }
  ]);
}
